var map = {
	"./affiliate-links.svg": 11255,
	"./affiliate-programs.svg": 24923,
	"./bb-academy.svg": 30911,
	"./bb-affiliate-program.svg": 67919,
	"./dashboard.svg": 45994,
	"./finances.svg": 59107,
	"./gdziekupicto.svg": 20084,
	"./reports.svg": 47863,
	"./settings.svg": 45657,
	"./tipbox.svg": 36496,
	"./widget-bb.svg": 135,
	"./your-pages.svg": 30204
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19006;